import React from 'react';
import css from './Page.module.css';
import classNames from 'classnames';

export const Page = ({
  children,
  className,
  large = false,
  style = {},
}: {
  large?: boolean;
  style?: any;
  children: any;
  className?: string;
}) => {
  return (
    <div className={css.outside}>
      <div style={style} className={classNames(large ? css.containerLarge : css.container, className)}>
        {children}
      </div>
    </div>
  );
};
